<section class="container-fluid mt-5">
    <app-filter (filterEvent)="filterEvent($event)" [showSearch]="true" [searchPlaceholder]="'ابحث بواسطة عنوان الخبر'" [showDateFrom]="true" [showDateTo]="true"></app-filter>

    <div  *ngFor="let item of Items">
        <app-archive-item [newsData]="item" ></app-archive-item>
    </div>
</section>